const TAuth = {
    // English
    "enUS": {
        'SIGN_IN_EMAIL': 'Email and Password',
        'LOGIN_TITLE': 'Signin and access our services',
        'SIGNUP_TITLE': 'Create Your Account',
        'BUSINESS_NOT_EXISTS': 'The business does not exists',
        'BUSINESS_ID_LABEL': 'Write the ID of your business',
        'BUSINESS_ID': 'Business ID',
        'EMAIL': 'Email',
        'YOUR_EMAIL': 'Your email',
        'NAME': 'Name',
        'YOUR_NAME': 'Your name',
        'LAST_NAME': 'Last name (Optional)',
        'YOUR_LAST_NAME': 'Your last name',
        'USERNAME': 'Username',
        'YOUR_USERNAME': 'Your username',
        'PASSWORD': 'Password',
        'YOUR_PASSWORD': 'Your password',
        'CONFIRM_PASSWORD': 'Confirm your password',
        'SIGN_UP': 'No account? Sign Up',
        'GOOGLE_EMAIL_NOT_VERIFIED': 'Your Google email is not verified',
        'GOOGLE_INFO_NOT_FOUND': "Email info not available",
        'INCORRECT_USERNAME_OR_PASSWORD': 'Incorrect username or password',
        'ACCOUNT_NOT_VERIFIED': 'Account needs to be verified',
        'ACCOUNT_SUSPENDED': 'Your account has been temporaly suspended',
        'ACCOUNT_BANNED': 'Your account has been permanently banned',
        'USERNAME_EXISTS': 'The username already exists',
        'EMAIL_EXISTS': 'An account created with that email already exists',
        'NO_ACCOUNT': "Don't have an account?",
        'HAVE_ACCOUNT': "Already have an account? Click here",
        'CLICK_HERE': "Click here!",
        'FORGOTTEN_PASSWORD': "Forgot your password?",
        'VERIFICATION_MAIL': "Resend verification email",
        'VERIFICATION_MAIL_SENT': "A verification mail has been sent, if it doesn't appear in a couple of minutes check your spam",
        'RESEND_EMAIL': "Resend email",
        'SEND': "Send",
        'ENTER_EMAIL_RECOVERY': "Enter an email so we can send you a password recovery link",
        'ENTER_EMAIL_VERIFICATION': "Enter an email so we can send you a verification link",
        'EMAIL_SENT': "An email has been sent, if it doesn't appear in a couple of minutes check your spam",
        'VERIFICATION_COMPLETE': "The verification process is now complete! You can now login with your account",
        'SOMETHING_WENT_WRONG': "Something went wrong, try again later :(",
        'RESET_PASSWORD': "Reset password",
        'RESET_PASSWORD_SUCCESS': "Your password has been reset, now you can login with your new password :)",
        'PASSWORDS_NO_MATCH': "The passwords do not match",
        'PASSWORDS_RESET_EXPIRED': "Your password reset expired, please request a new one",
        'RESET_YOUR_PASSWORD': "Reset your password",
        'TERMS_OF_SERVICE': "I have read and accept the ",
        'TERMS_OF_SERVICE_LINK': "terms of service",
        'TERMS_OF_SERVICE_REQUIRED': "You must accept the terms of service",
        'CONTINUE': "Continue",
        'LOGIN': "Login",
        'SIGNIN': "Login",
        'SIGNIN_GOOGLE': "Sign in with Google",
        'SIGNIN_APPLE': "Sign in with Apple",
        'CREATE_YOUR_ACCOUNT': "Create your account",

        'NEXT': "Next",
        'CANCEL': "Cancel",
        'RETURN': "Return",
        'CREATE': "Create",

        'OR': "Or",

        'OTHER_LOGIN_OPTIONS': 'Other Login Options',

        'STEP_1': 'Step 1/2',
    },
    // Spanish
    "esMX": {
        'SIGN_IN_EMAIL': 'Correo y Contraseña',
        'LOGIN_TITLE': 'Ingresa y accede a nuestros servicios',
        'SIGNUP_TITLE': 'Crea Tu Cuenta',
        'BUSINESS_NOT_EXISTS': 'No se encontró un negocio con esa ID',
        'BUSINESS_ID_LABEL': 'Ingresa el ID de tu negocio',
        'BUSINESS_ID': 'ID del negocio',
        'EMAIL': 'Correo',
        'YOUR_EMAIL': 'Tu correo',
        'NAME': 'Nombre',
        'YOUR_NAME': 'Tu nombre',
        'LAST_NAME': 'Apellidos (Opcional)',
        'YOUR_LAST_NAME': 'Tus apellidos',
        'USERNAME': 'Usuario',
        'YOUR_USERNAME': 'Tu usuario',
        'PASSWORD': 'Contraseña',
        'YOUR_PASSWORD': 'Tu contraseña',
        'CONFIRM_PASSWORD': 'Confirma tu contraseña',
        'SIGN_UP': '¿Sin cuenta? Registrate',
        'GOOGLE_EMAIL_NOT_VERIFIED': 'Tu email de Google no ha sido verificado',
        'GOOGLE_INFO_NOT_FOUND': "La información de tu email no está disponible",
        'INCORRECT_USERNAME_OR_PASSWORD': 'Usuario o contraseña incorrecto',
        'ACCOUNT_NOT_VERIFIED': 'La cuenta no ha sido verificada',
        'ACCOUNT_SUSPENDED': 'Tu cuenta ha sido temporalmente suspendida',
        'ACCOUNT_BANNED': 'Tu cuenta ha sido permanentemente banneada',
        'USERNAME_EXISTS': 'El usuario ya existe',
        'EMAIL_EXISTS': 'Ya existe una cuenta con el correo ingresado',
        'NO_ACCOUNT': "No tienes una cuenta?",
        'HAVE_ACCOUNT': "¿Ya tienes una cuenta?",
        'CLICK_HERE': "Haz click aquí!",
        'FORGOTTEN_PASSWORD': "Olvidaste tu contraseña?",
        'VERIFICATION_MAIL': "Reenviar correo de verificación",
        'VERIFICATION_MAIL_SENT': "Se ha enviado un correo de verificación, si no aparece en unos cuantos minutos checa tu bandeja de correo no deseado",
        'RESEND_EMAIL': "Reenviar correo",
        'SEND': "Enviar",
        'ENTER_EMAIL_RECOVERY': "Ingresa tu correo para que podamos enviarte un enlace de recuperación de contraseña",
        'ENTER_EMAIL_VERIFICATION': "Ingresa tu correo para que podamos enviarte un enlace de verificación",
        'EMAIL_SENT': "Se ha enviado un correo, si no aparece en unos cuantos minutos checa tu bandeja de correo no deseado",
        'VERIFICATION_COMPLETE': "El proceso de verificación ha sido completado! Ahora puedes iniciar sesión con tu cuenta",
        'SOMETHING_WENT_WRONG': "Algo salió mal, intenta de nuevo luego :(",
        'RESET_PASSWORD': "Reiniciar contraseña",
        'RESET_PASSWORD_SUCCESS': "Tu contraseña ha sido reiniciada, ahora puedes iniciar sesión con tu nueva contraseña :)",
        'PASSWORDS_NO_MATCH': "Las contraseñas no son iguales",
        'PASSWORDS_RESET_EXPIRED': "Tu reinicio de contraseña ha expirado, porfavor solicita uno nuevo",
        'RESET_YOUR_PASSWORD': "Reinicia tu contraseña",
        'TERMS_OF_SERVICE': "He leído y acepto los ",
        'TERMS_OF_SERVICE_LINK': "términos de uso y de servicio",
        'TERMS_OF_SERVICE_REQUIRED': "Debes aceptar los términos de uso y de servicio",
        'CONTINUE': "Continuar",
        'LOGIN': "Acceder",
        'SIGNIN': "Inicia sesión",
        'SIGNIN_GOOGLE': "Inicia sesión con Google",
        'SIGNIN_APPLE': "Acceder con Apple",
        'CREATE_YOUR_ACCOUNT': "Crea tu cuenta",

        'NEXT': "Continuar",
        'CANCEL': "Cancelar",
        'RETURN': "Regresar",
        'CREATE': "Crear",

        'OR': "o",

        'OTHER_LOGIN_OPTIONS': 'Otras Opciones de Ingreso',
        'STEP_1': 'Paso 1/2',
    }
}
export default TAuth;